var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#427c7f"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.432,6.577,4.568,9.806a.236.236,0,0,0,.2.353H7.123a.227.227,0,0,1,.227.227v2.461a.446.446,0,0,0,.891,0V10.4a.236.236,0,0,1,.235-.236h2.342a.235.235,0,0,0,.2-.353S9.185,6.62,9.164,6.586a.065.065,0,0,1,.053-.1H9.94a.235.235,0,0,0,.2-.353L8,2.416a.236.236,0,0,0-.408,0L5.446,6.132a.235.235,0,0,0,.2.353h.726A.067.067,0,0,1,6.432,6.577Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPark);
export default __webpack_public_path__ + "static/media/PARK.6aab5c733834136cf14810437bbaa77a.svg";
export { ForwardRef as ReactComponent };